// TODO: to be deprecated
export const i18nAlarmPage = {
  sections: {
    prediction_graph: 'Failure risk model',
    pump_curve: 'Pump curve',
    sensors_graph: 'Sensors data',
    analysis: 'Analysis',
    history: 'Historic',
    alarms_list: 'Latest alarms {{asset}}',
    flat_line_graph: 'Flat line',
    diagnostic: 'Diagnostic',
    recommendation: 'Recommendations',
  },
  components: {
    alarm_summary: {
      start_time: 'Start',
      end_time: 'End',
      asset_name: 'Asset',
      description: 'Alarm description',
      status: 'Status',
      classification: 'Classification',
      model: 'Model',
      id: 'Alarm id',
    },
    analysis: {
      fields: {
        status: 'Status',
        classification: 'Classification',
        action: 'Operator action',
        work_order: 'Work order (number)',
        reason: 'Reason',
        failure_occurred: 'There was failure?',
        additional_info: 'Additional info',
        end_date: 'Estimate to complete investigation',
      },
      actions: {
        attach: 'Attach file',
        save: 'Save',
        attachments: 'Attachments',
        required_field: 'Required field',
        max_length: 'Max size {{size}} characters',
      },
    },
    suspension: {
      suspend_new_alarms: 'Suspend new alarms for a period',
      this_model_no_alarms: 'This model will not generate new alarms until the date below.',
      select_date: 'Select date',
    },
    history: {
      comment_placeholder: 'Leave a comment',
      empty_history: 'Alarm without change history',
      action_title: {
        attach_file: 'Attached file',
        remove_file: 'Removed file',
        status_change: '{{userName}} changed alarm status',
        change_end_date: '{{userName}} changed end date',
        add_work_order: '{{userName}} added WorkOrder number',
        add_details: '{{userName}} added diagnosis',
      },
      action: {
        attach_file: '{{userName}} attached {{filename}}',
        remove_file: '{{userName}} removed {{filename}}',
        status_change: '{{userName}} changed status from {{previousStatus}} to {{currentStatus}}',
        change_end_date: '{{userName}} changed end date to {{endDate}}',
        add_work_order: '{{userName}} added WorkOrder number: {{workOrder}}',
        add_details: '{{userName}} added diagnosis: {{details}}',
      },
    },
    sensors_graph: {
      variables_contribution: 'Variables contribution',
    },
  },
  message: {
    generic_error: {
      title: 'Ops..',
      message: 'Unexpected error occurred. Try again on few minutes',
    },
    inexistent_alarm: {
      title: 'Alarm not found',
      message: 'Please try with a valid alarm id',
    },
    features_contribution_error: {
      title: 'Ops..',
      message: 'An error occurred to load features contribution data',
    },
    analysis_submit: {
      success: { title: 'Success', message: 'Analysis submited' },
      error: { title: 'Error', message: 'Analysis submit failure' },
    },
  },
};
